import { useContext } from 'react';

import { PermissionContext } from '@/features/auth/permission-context';

/** Access role and permission checks. Throws outside PermissionProvider. */
export function usePermissions() {
  const context = useContext(PermissionContext);
  if (context === null) {
    throw new Error('usePermissions must be used inside <PermissionProvider>');
  }
  return context;
}
